<template>
<div class="frequent-visit-page-wrapper">
  <div class="title">자주 방문하는 페이지</div>
  <el-row v-for="row in maxRowCount" :key="row" :gutter="20" style="margin-bottom: 24px">
    <el-col :span="maxColCount" v-for="col in maxColCount" :key="row + '.' + col">
      <div class="page-box" v-if="isPageIndex(row, col)" @click="routeFrequentlyPage(row, col)">
        <div class="img">
          <div :class="['nav-menu', getPageMenuIcon(row, col)]" />
        </div>
        <el-tooltip effect="dark" :content="getPageLabel(row, col)">
        <div class="label">
          {{ getPageLabel(row, col) }}
        </div>
      </el-tooltip>
      </div>
      <div v-else class="page-box empty" />
    </el-col>
  </el-row>
</div>
</template>

<script>
import MsgUtil from '@/utils/message';
import { routeByPathAfterCheckValid } from '@/utils/router';
import BookmarkAPI from '@/api/frame/bookmark';

export default {
  name: 'WFrequentVisitPageView',
  computed: {
    managerId() {
      return this.$store.getters.userInfo.managerId;
    },
  },
  data() {
    return {
      routeByPathAfterCheckValid,
      /**
       * 최대 행 개수
       * @type {Number}
       */
      maxRowCount: 2,
      /**
       * 최대 열 개수
       * @type {Number}
       */
      maxColCount: 5,
      /**
       * 자주 방문하는 페이지 정보
       * @type {Array}
       */
      pages: [],
    };
  },
  methods: {
    /**
     * 자주 방문하는 페이지 조회
     * @author Hunui
     * @return {[type]} [description]
     */
    loadData() {
      const limit = this.maxRowCount * this.maxColCount;

      const params = {
        start: 0,
        limit,
        managerId: this.managerId,
        searchType: 'contain', // 즐겨찾기 포함
      };

      const target = '자주 방문하는 페이지';
      const action = MsgUtil.action.VIEW;

      BookmarkAPI.getFrequentlyPageList(params)
        .then((response) => {
          if (response.data.success) {
            this.pages = response.data.data;
          } else {
            this.$message(MsgUtil.getResultMsgData(action, target, false));
          }
        })
        .catch((e) => {
          this.$message(MsgUtil.getResultMsgData(action, target, false));
          throw new Error(e);
        });
    },
    /**
     * 행/열에 맞는 인덱스를 반환한다..
     * @author Ju
     * @param  {[type]} row
     * @param  {[type]} col
     * @return {[type]} index
     */
    getIndex(row, col) {
      return (row > 1 ? (row - 1) * this.maxColCount : 0) + (col - 1);
    },
    /**
     * 자주 방문하는 페이지가 있는 인덱스인지 확인한다.
     * @author Ju
     * @param  {[type]}  row
     * @param  {[type]}  col
     * @return {Boolean}
     */
    isPageIndex(row, col) {
      return this.getIndex(row, col) < this.pages.length;
    },
    /**
     * 자주 방문하는 페이지의 메뉴 아이콘을 반환한다.
     * @author Ju
     * @param  {[type]} row
     * @param  {[type]} col
     * @return {[type]}     메뉴 아이콘 클래스
     */
    getPageMenuIcon(row, col) {
      return this.pages[this.getIndex(row, col)].menuIcon;
    },
    /**
     * 자주 방문하는 페이지의 라벨을 반환한다.
     * @author Ju
     * @param  {[type]} row
     * @param  {[type]} col
     * @return {[type]} 경로 라벨
     */
    getPageLabel(row, col) {
      return this.pages[this.getIndex(row, col)].pathDesc;
    },
    /**
     * 자주 방문하는 페이지 선택 시 페이지 이동
     * @author Hunui
     * @param  {[type]} row
     * @param  {[type]} col
     */
    routeFrequentlyPage(row, col) {
      const path = this.pages[this.getIndex(row, col)].path;

      routeByPathAfterCheckValid(this, path, () => {
        this.$confirm(...MsgUtil.getCustomConfirmData('선택한 경로가 삭제되어 이동할 수 없습니다. 자주 방문하는 페이지에서 삭제하시겠습니까?')).then(() => {
          const deleteParams = {
            pathList: [{ path }],
          };
          this.deleteVisitPage(deleteParams);
        });
      }, true);
      // this.$store.dispatch('closeSmartSearchPopup');
    },
    /**
     * 자주 방문하는 페이지의 경로가 사라졌을 경우 삭제한다.
     * @author Hunui
     * @param  {[type]} param [description]
     * @return {[type]}       [description]
     */
    deleteVisitPage(param) {
      const action = MsgUtil.action.DELETE;
      const target = '자주 방문하는 페이지';
      BookmarkAPI.deleteFrequentlyPage(param).then((response) => {
        if (response.data.success) {
          this.$message(MsgUtil.getResultMsgData(action, target, true));
          this.loadData();
        } else {
          this.$message(MsgUtil.getResultMsgData(action, target, false));
        }
      }).catch((e) => {
        this.$message(MsgUtil.getResultMsgData(action, target, false));
        throw new Error(e);
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/frame/components/popup/SmartSearchPopup/SearchView/FrequentVisitPageView.vue